module.exports = __webpack_public_path__ + "img/3.4bb3e24a.png";